import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { API } from '@/constants/bluemonk';

export const AdminSettingsSection = ({ config, headers, onRefresh }) => {
  const [pin, setPin] = useState('');

  const handleUpdatePin = async () => {
    if (pin.length !== 6 || !/^\d+$/.test(pin)) {
      toast.error('PIN must be 6 digits');
      return;
    }
    try {
      await axios.put(`${API}/admin/config/pin`, { pin }, { headers });
      toast.success('PIN updated successfully');
      setPin('');
      onRefresh();
    } catch (error) {
      toast.error('Failed to update PIN');
    }
  };

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">Settings</h1>

      <Card className="p-6">
        <h2 className="text-lg font-semibold mb-4">Client Access PIN</h2>
        <p className="text-sm text-slate-500 mb-4">
          Current PIN: <span className="font-mono font-bold">{config?.clientPin || '******'}</span>
        </p>
        <div className="flex items-center gap-4">
          <Input
            type="text"
            placeholder="New 6-digit PIN"
            value={pin}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 6))}
            className="w-40 font-mono text-center text-lg"
            maxLength={6}
          />
          <Button onClick={handleUpdatePin}>
            Update PIN
          </Button>
        </div>
      </Card>
    </div>
  );
};
